import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    postV2ProviderTelehealthJoinLink: build.mutation<
      PostV2ProviderTelehealthJoinLinkApiResponse,
      PostV2ProviderTelehealthJoinLinkApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/telehealth/join-link`,
        method: "POST",
        body: queryArg.joinLinkRequest,
      }),
    }),
    postV2ProviderTelehealthNotifyPatient: build.mutation<
      PostV2ProviderTelehealthNotifyPatientApiResponse,
      PostV2ProviderTelehealthNotifyPatientApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/telehealth/notify-patient`,
        method: "POST",
        body: queryArg.notifyPatientRequest,
      }),
    }),
    postV2ProviderTelehealthPatientLink: build.mutation<
      PostV2ProviderTelehealthPatientLinkApiResponse,
      PostV2ProviderTelehealthPatientLinkApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/telehealth/patient-link`,
        method: "POST",
        body: queryArg.joinLinkRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type PostV2ProviderTelehealthJoinLinkApiResponse =
  /** status 200 OK */ JoinLinkResponse;
export type PostV2ProviderTelehealthJoinLinkApiArg = {
  joinLinkRequest: JoinLinkRequest;
};
export type PostV2ProviderTelehealthNotifyPatientApiResponse =
  /** status 200 OK */ NotifyPatientResponse;
export type PostV2ProviderTelehealthNotifyPatientApiArg = {
  notifyPatientRequest: NotifyPatientRequest;
};
export type PostV2ProviderTelehealthPatientLinkApiResponse =
  /** status 200 OK */ PatientLinkResponse;
export type PostV2ProviderTelehealthPatientLinkApiArg = {
  joinLinkRequest: JoinLinkRequest;
};
export type JoinLinkResponse = {
  /** Token expiration time */
  expires_at?: string | null;
  /** Whether this token grants owner privileges */
  is_owner: boolean;
  /** Daily room name */
  room_name: string;
  /** Daily room URL */
  room_url: string;
  /** Short URL for patient to join (generates fresh token on click) */
  short_url?: string | null;
  /** Meeting token for joining the room */
  token: string;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type JoinLinkRequest = {
  /** Appointment ID to get join link for */
  appointment_id: string;
};
export type NotifyPatientResponse = {
  /** Channels that were attempted */
  channels_attempted: string[];
  /** Channels that succeeded */
  channels_successful: string[];
  /** Whether patient contact information was updated */
  contact_updated?: boolean;
  /** Errors per channel if any */
  errors?: {
    [key: string]: string;
  };
  /** The short URL that was sent */
  short_url: string;
  /** Whether notification was successful */
  success: boolean;
  /** Celery task IDs per channel */
  task_ids?: {
    [key: string]: string;
  };
};
export type NotifyPatientRequest = {
  /** Appointment ID */
  appointment_id: string;
  /** Channels to use: ['sms'], ['email'], or ['sms', 'email'] */
  channels: string[];
  /** Patient email address */
  email?: string | null;
  /** Patient phone number (E.164 format, e.g., +15551234567) */
  mobile_phone?: string | null;
};
export type PatientLinkResponse = {
  /** Short URL for patient to join telehealth session */
  short_url: string;
};
